// @flow
import gql from 'graphql-tag';
import React from 'react';
import {connect} from 'react-redux';
import {CollapsibleLinkpile} from '@homeaway/react-linkpile';
import {media} from '../../utils/breakpoints';

import type {State as ReduxState} from '../../reducers/index';

import './SeoLinkpile.less';

type OwnProps = {
    title?: string,
    categories?: []
};

type StateProps = {
    isMobile: boolean,
    site: string
};

export type Props = OwnProps & StateProps;

export const fragments = {
    results: gql`
        fragment SeoLinkpileResults on Results {
            seoLinkpile {
                title
                categories {
                    title
                    links {
                        text
                        url
                    }
                }
            }
        }
    `
};

const SeoLinkpile = class extends React.Component<Props> {
    static defaultProps = {
        categories: []
    };

    render() {
        return <CollapsibleLinkpile forceExpanded {...this.props} />;
    }
};

const mapStateToProps = (state: ReduxState): StateProps => ({
    isMobile: !media(state.viewport.breakpoint, {minWidth: 'SM_MIN'}),
    site: state.system.siteName
});

export default connect(mapStateToProps)(SeoLinkpile);
